<div class="login-form-container" [ngClass]="{'pe-none': loading}">
  @if (!registrationNeeded) {
  <form [formGroup]="loginform" (ngSubmit)="send()" animate.enter="loaded-fade-enter">
    <div class="form-group">
      <label for="User" class="form-label">Iniciar sesión</label>
      <input id="User" formControlName="User" type="email" class="form-control custom-input" placeholder="Email de empresa*" inputmode="email" [ngClass]="{'is-invalid':loginform.get('User').invalid && submitted == 1 , 'is-valid':loginform.get('User').valid && submitted == 1}" autocomplete="email">
      <div class="invalid-tooltip">
        <div class="msn" [hidden]="!loginform.controls['User'].errors || !loginform.controls['User'].errors['required']">
          Campo requerido.
        </div>
        <div class="msn" [hidden]="!loginform.controls['User'].errors || !loginform.controls['User'].errors['email']">
          Debe contener una dirección de email válida.
        </div>
        <div class="msn" [hidden]="!loginform.controls['User'].errors || !loginform.controls['User'].errors['maxlength']">
          Límite de caracteres superado.
        </div>
      </div>
      <div class="form-text">* Acceso por invitación</div>
    </div>

    @if (invalidUser) {
    <div id="warning" class="warning-login-message" animate.enter="loaded-height-enter" animate.leave="loaded-height-leave">
      No se ha encontrado tu cuenta o no ha sido posible procesar tu solicitud en este momento, por favor inténtalo
      de nuevo.
    </div>
    }

    <div class="button-container">
      <button type="submit" class="btn btn-primary btn-sm w-100" [disabled]="loading">{{submitText}}</button>
    </div>
  </form>
  }

  @if (registrationNeeded && countOtpFailed < 3) { <!-- -->
    <form [formGroup]="otpform" (ngSubmit)="LoginOtp()" class="login-form" animate.enter="loaded-fade-enter">
      <div class="form-group">
        <label for="OtpCode" class="form-label">Introduce el código que te hemos enviado por email</label>
        <input id="OtpCode" formControlName="OtpCode" type="text" class="form-control custom-input" placeholder="Código" maxlength="6" [ngClass]="{'is-invalid':otpform.get('OtpCode').invalid && submittedOtp == 1 , 'is-valid':otpform.get('OtpCode').valid && submittedOtp == 1}">
        <div class="invalid-tooltip">
          <div class="msn" [hidden]="!otpform.controls['OtpCode'].errors || !otpform.controls['OtpCode'].errors['required']">
            Campo requerido.
          </div>
          <div class="msn" [hidden]="!otpform.controls['OtpCode'].errors || !otpform.controls['OtpCode'].errors['maxlength']">
            El código debe constar de 6 caracteres.
          </div>
          <div class="msn" [hidden]="!otpform.controls['OtpCode'].errors || !otpform.controls['OtpCode'].errors['minlength']">
            El código debe constar de 6 caracteres.
          </div>
        </div>
        @if (!otpStatus) {
        <div class="invalid-tooltip d-block">
          Código incorrecto, revísalo e intentalo de nuevo.
        </div>
        }
      </div>

      <div class="button-container">
        <button type="submit" class="btn btn-primary btn-sm w-100" [disabled]="loading">Enviar código</button>
      </div>
    </form>
    }

    @if (!otpStatus && countOtpFailed >= 3) {
    <div id="warning" class="warning-login-message" animate.enter="loaded-height-enter" animate.leave="loaded-height-leave">
      Código incorrecto, se ha excedido el número máximo de intentos fallidos.
      <button (click)="resetAll()" type="button" class="btn btn-primary btn-sm">Volver a intentar</button>
    </div>
    }
</div>


<!-- Loader -->
@if (loading) {
<div class="loader">
  <div class="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
}
